import styled, { keyframes } from 'styled-components';
import { backgroundTheme, media } from '../../styles/style-utils';

const spinLogoKeyframes = keyframes`
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
`;

export const ResearchCardWrapper = styled.div`
  width: 100%;
  margin: 6rem 0 4rem;
  display: flex;
  flex-direction: column;
  position: relative;

  .logo {
    animation: ${spinLogoKeyframes} 12s linear infinite forwards;
  }
`;

export const LogoWrapper = styled.div`
  position: absolute;
  left: 50%;
  top: -20px;
  width: 40px;
  height: 40px;
  margin: 0 0 0 -20px;
  z-index: 1;
`;

export const FoodSection = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;

  a {
    text-decoration: none;
  }
`;

export const ResultsSection = styled.div`
  padding: 1rem;
  position: relative;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`;

export const StyledFoodName = styled.h1`
  font-size: 2rem;
  ${media.fromMedium`font-size: 3rem;`}
  text-align: right;
  margin: 0;

  > a {
    display: block;
    padding: 1rem;
    color: inherit;
    position: relative;
    z-index: 2;
    background: ${props => props.themeColors[0]};
    color: ${props => props.textColor};
  }
`;

export const StyledIntroHeading = styled.h3`
  margin: 0.5rem auto;
  font-size: 1.6rem;
`;

export const StyledPreventsHeading = styled.h1`
  font-size: 2rem;
  ${media.fromMedium`font-size: 3rem;`}
  margin: 1rem 0 1.1rem -0.2rem;
  position: relative;

  > a {
    padding: 1rem;
    display: block;
    position: relative;
    z-index: 2;
    background: ${props => props.themeColors[0]};
    color: ${props => props.textColor};
    min-width: 200px;
  }

  &::after {
    content: '';
    display: block;
    position: absolute;
    top: -70px;
    height: 95px;
    width: 120%;
    margin: 0 0 0 -10%;
    ${media.fromMedium`
      width: 140%;
      margin: 0 0 0 -20%;
    `}
    ${media.fromLarge`
      width: 160%;
      margin: 0 0 0 -30%;
    `}
    border: 1px solid ${props => _.takeRight(props.themeColors)};
    border-radius: 5px;
    z-index: 1;
  }
`;

export const Links = styled.div`
  position: absolute;
  bottom: 1rem;
  right: 2rem;
`;



// WEBPACK FOOTER //
// ./src/components/ResearchCard/ResearchCardStyles.js